module.exports = __webpack_public_path__ + "static/media/about-us-history-1.b431012b.webp";